document.addEventListener("turbo:load", function () {
    if (typeof fbq === 'function') {
        fbq('track', 'PageView');
    }
});
